import { useQuery } from "@tanstack/react-query";
import { useCatalog } from "@/lib/catalog";
import { api } from "@/lib/api";
/** Ícones em traço (sem dependências). Uso: <Icon name="home" /> */
const P: Record<string, JSX.Element> = {
  home: <><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /></>,
  check: <><rect x="3" y="4" width="18" height="17" rx="3" /><path d="M8 12l3 3 5-6" /></>,
  cal: <><rect x="3" y="5" width="18" height="16" rx="3" /><path d="M3 10h18M8 3v4M16 3v4" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21c1.5-4 5-6 8-6s6.5 2 8 6" /></>,
  folder: <path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2z" />,
  scale: <><path d="M12 3v18M5 21h14M6 7h12" /><path d="M6 7l-3 7a4 3 0 006 0zM18 7l-3 7a4 3 0 006 0z" /></>,
  radar: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><path d="M12 12l6-6" /></>,
  doc: <><path d="M6 3h8l5 5v13H6z" /><path d="M14 3v5h5M9 13h6M9 17h6" /></>,
  chat: <><path d="M4 5h16v11H9l-5 4z" /><path d="M8 9h8M8 12h5" /></>,
  pin: <><path d="M5 4h14v11l-5 5H5z" /><path d="M14 20v-5h5" /></>,
  bot: <><rect x="4" y="8" width="16" height="11" rx="3" /><path d="M12 4v4M9 13h.01M15 13h.01M9 16h6" /></>,
  coin: <><circle cx="12" cy="12" r="9" /><path d="M15 9.5c-.5-1-1.6-1.5-3-1.5-2 0-3 1-3 2.2 0 3 6 1.5 6 4.6 0 1.2-1 2.2-3 2.2-1.5 0-2.6-.6-3.1-1.6M12 6v2M12 16v2" /></>,
  chart: <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />,
  gear: <><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></>,
  bell: <><path d="M6 8a6 6 0 1112 0c0 7 3 8 3 8H3s3-1 3-8" /><path d="M10 20a2 2 0 004 0" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  flag: <path d="M5 21V4M5 4h11l-2 4 2 4H5" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  alert: <><path d="M12 3l10 18H2z" /><path d="M12 10v4M12 17.5v.5" /></>,
  list: <path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01" />,
  board: <><rect x="3" y="4" width="5" height="16" rx="1.5" /><rect x="10" y="4" width="5" height="11" rx="1.5" /><rect x="17" y="4" width="4" height="7" rx="1.5" /></>,
  chev: <path d="M9 6l6 6-6 6" />,
  ext: <><path d="M14 4h6v6M20 4l-9 9" /><path d="M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5" /></>,
  tick: <path d="M5 12l5 5 9-10" />,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  upload: <path d="M12 16V4M7 9l5-5 5 5M4 20h16" />,
  moon: <path d="M20 14.5A8 8 0 019.5 4a8 8 0 1010.5 10.5z" />,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></>,
  logout: <><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" /><path d="M16 17l5-5-5-5M21 12H9" /></>,
  inbox: <><path d="M3 13l3-8h12l3 8v6a1 1 0 01-1 1H4a1 1 0 01-1-1z" /><path d="M3 13h5l1 2h6l1-2h5" /></>,
  help: <><circle cx="12" cy="12" r="9" /><path d="M9.5 9.5a2.5 2.5 0 015 .3c0 1.7-2.5 2-2.5 3.7M12 17h.01" /></>,
  building: <><path d="M4 21V5a1 1 0 011-1h9a1 1 0 011 1v16M15 9h4a1 1 0 011 1v11M3 21h18" /><path d="M8 8h3M8 12h3M8 16h3" /></>,
  flow: <><rect x="3" y="3" width="6" height="6" rx="1.5" /><rect x="15" y="15" width="6" height="6" rx="1.5" /><path d="M6 9v4a2 2 0 002 2h7M18 15V9a2 2 0 00-2-2h-7" /></>,
  chevdown: <path d="M6 9l6 6 6-6" />,
  chevleft: <path d="M15 6l-6 6 6 6" />,
  bulb: <><path d="M9 18h6M10 21h4" /><path d="M12 3a6 6 0 00-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0012 3z" /></>,
  cash: <><rect x="3" y="6" width="18" height="12" rx="2" /><circle cx="12" cy="12" r="2.5" /><path d="M6 9v.01M18 15v.01" /></>,
  briefcase: <><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2M3 13h18" /></>,
  palette: <><circle cx="12" cy="12" r="9" /><circle cx="8" cy="10" r="1.2" /><circle cx="12" cy="7.5" r="1.2" /><circle cx="16" cy="10" r="1.2" /><path d="M12 21a2 2 0 010-4h2a3 3 0 003-3" /></>,
};

export function Icon({ name, size, className = "" }: { name: keyof typeof P | string; size?: "sm"; className?: string }): JSX.Element {
  return (
    <svg className={`ic ${size ?? ""} ${className}`} viewBox="0 0 24 24" aria-hidden="true">
      {P[name] ?? P.doc}
    </svg>
  );
}

const AV_COLORS = ["#34506F", "#2D5DA8", "#2F7D4F", "#6D4AB0", "#B8650F", "#0E7490", "#9D174D", "#4D7C0F"];

export function initials(name: string): string {
  return name.split(/\s+/).filter((p) => p && p.length > 2).slice(0, 2).map((p) => p[0]).join("").toUpperCase()
    || name.slice(0, 2).toUpperCase();
}

/** Foto de perfil (se houver) ou iniciais com cor estável por pessoa. `id` = usuário do escritório. */
export function Avatar({ name, id, size = 26 }: { name: string; id?: string | null; size?: number }): JSX.Element {
  const { data: cat } = useCatalog();
  const v = id ? cat?.users.find((u) => u.id === id)?.avatarUpdatedAt : null;
  const { data: src } = useQuery({
    queryKey: ["avatar", id, v], enabled: !!id && !!v, staleTime: Infinity, gcTime: 3_600_000,
    queryFn: () => api.blobUrl(`/usuarios/${id}/avatar?v=${encodeURIComponent(v ?? "")}`),
  });
  const key = id ?? name;
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  if (src) return <img className="avatar" src={src} alt={name} title={name} style={{ width: size, height: size, objectFit: "cover", padding: 0 }} />;
  return (
    <span className="avatar" title={name} style={{ width: size, height: size, fontSize: Math.round(size * 0.42), background: AV_COLORS[h % AV_COLORS.length] }}>
      {initials(name)}
    </span>
  );
}
